import React from 'react'
import { Create, SimpleForm, TextInput } from 'react-admin'

export const TagCreate = props => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="name" />
      <TextInput source="description" />
    </SimpleForm>
  </Create>
)
